import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function Classes() {
    
    const { t } = useTranslation();

    useEffect(() => {

        let arr = {};
        for (let i = 1; i <= 12; i++) {
            arr[i] = t("classNames",  { returnObjects: true })[i]
        }
        global.Classes = arr;


        let arr2 = {};
        for (let i = 1; i <= 7; i++) {
            arr2[i] = t("gradeNames",  { returnObjects: true })[i]
        }
        global.Classes = arr;
        global.Grades = arr2;
      
        
        // onload(true);


    }, []);


    return (
        <>
        </>
    );
}
